Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for(var key in params) {
        var hiddenField = document.createElement("input");
        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

$(document).ready(function(){
    // Ingredient animation

    var timeout;
    $('.ingredient').on('mousemove',function(e){
        if ($(window).width() > 1024) {
            if(timeout) clearTimeout(timeout);
            setTimeout(callParallax.bind(null, e), 200);
        }
    });

    function callParallax(e){
        parallaxIt(e, e.currentTarget, - 75);
    }

    function parallaxIt(e, target, movement){
        var $this = $(e.currentTarget);
        var relX = e.pageX - $this.offset().left;
        var relY = e.pageY - $this.offset().top;

        gsap.to(target, 1, {
            x: (relX - $this.width()/2) / $this.width() * movement,
            y: (relY - $this.height()/2) / $this.height() * movement,
            ease: Power2.easeOut
        })
    }

    $('.cart-open').on('click',function(e){
        e.preventDefault();

        $('body').removeClass('site-nav-open');
        $('.nav-trigger, .site-nav, .site-nav__overlayer, .site-header').removeClass('open');

        setTimeout(function() {
            $('.cart-popup').addClass('visible');
            $('.cart-overlay').addClass('visible');
        }, 400)
    });

    $('.cart-close, .cart-overlay').on('click',function(e){
        e.preventDefault();
        $('.cart-popup').removeClass('visible');
        $('.cart-overlay').removeClass('visible');
        updateCartCount();
    });

    $(document).on('click','.cart-close',function(e){
        e.preventDefault();
        $('.cart-popup').removeClass('visible');
        $('.cart-overlay').removeClass('visible');
        updateCartCount();
    })

    $('.collections-nav a').on('click',function(e){
        if ($(this).attr('data-target')) {
            e.preventDefault();
            $('.collections-nav a').removeClass('active');
            $(this).addClass('active');
        }
    })

    if ($('.logo__inner').length) {

        // const slides_per_view = (window.innerWidth < 990) ? 4 : 8;
        // const space_between = (window.innerWidth < 990) ? 10 : 20;
        // new Swiper('.logo__inner', {
        //     slidesPerView: slides_per_view,
        //     initialSlide: 2,
        //     speed: 1000,
        //     spaceBetween: space_between,
        //     loop: true,
        //     centeredSlides: true,
        //     roundLengths: true,
        //     draggable: false,
        //     grabCursor: true,
        //     autoplay: {
        //         delay: 1000
        //     }
        // });

        // Tiny Slider
        const logoSlider = tns({
            container: '.logo__inner .slider-container',
            loop: true,
            items: 8,
            gutter: 10,
            nav: false,
            autoplay: true,
            autoplayHoverPause: true,
            autoplayButtonOutput: false,
            speed: 4000,
            autoplayTimeout: 0,
            preventActionWhenRunning: true,
            mouseDrag: false,
            controls: false,
            preventScrollOnTouch: false,
            responsive: {
                320: {
                    items: 3,
                },
                640: {
                    items: 4,
                },
                800: {
                    items: 6,
                },
                1200: {
                    items: 8,
                }
            }
        });


        // function productSlider() {
        //     const slides_per_view = (window.innerWidth < 990) ? 4 : 8;
        //     const space_between = (window.innerWidth < 990) ? 10 : 20;
        //     const swiper = new Swiper('.logo__inner', {
        //         loop: true,
        //         slidesPerView: slides_per_view,
        //         spaceBetween: space_between,
        //         speed: 400,
        //         centeredSlides: true,
        //         grabCursor: true,
        //         preloadImages: false,
        //         lazy: true,
        //         autoHeight: true,
        //         allowTouchMove: false,
        //         draggable: false,
        //         autoplay: {
        //             delay: 1000,
        //         },
        //         loopFillGroupWithBlank: false
        //     });
        // }

        // window.addEventListener("load", function () {
        //     productSlider();
        // });
        // window.addEventListener("resize", productSlider);

    }

    if ($('.featured-slider')) {
        const swiper = new Swiper('.featured-slider', {
            loop: false,
            slidesPerView:1,
            spaceBetween:30,
            centeredSlides:false,
            slidesOffsetBefore: 10,
            speed: 750,
            freeMode: {
                enabled: true,
                sticky: false,
            },
            mousewheel: {
                releaseOnEdges: true,
                forceToAxis:true
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    centeredSlides:false,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 250,
                    centeredSlides:false,
                    slidesOffsetBefore: 185
                },
                // 1600: {
                //     spaceBetween: 240,
                //     slidesPerView: 2.5,
                //     slidesOffsetBefore: 150
                // },
                // 1920: {
                //     spaceBetween: 200,
                //     slidesPerView: 3.2,
                //     slidesOffsetBefore: 300
                // }
            }
        });
    }

    if ($('.about-slider')) {
        const swiper = new Swiper('.about-slider', {
            loop: false,
            slidesPerView:1,
            speed: 400,
            pagination: false,
            spaceBetween:30,
            freeMode: {
                enabled: true,
                sticky: false,
            },
            mousewheel: {
                releaseOnEdges: true,
                forceToAxis:true
            },
            scrollbar: {
                el: '.swiper-scrollbar',
                draggable: true,
            },
            breakpoints: {
                640: {
                    slidesPerView: 1,
                    centeredSlides:false,
                },
                1024: {
                    slidesPerView: 'auto',
                    spaceBetween: 40,
                }
            }
        });
    }

    if ($('.content-slider')) {
        const swiper = new Swiper('.content-slider', {
            loop: false,
            slidesPerView: 1,
            speed: 400,
            centeredSlides: true,
            grabCursor: true,
            autoplay: {
                delay: 3000,
            },
            pagination: {
                el: '.swiper-pagination-image-with-text-overlay',
                type: 'bullets',
                clickable: true
            }
        });
    }

    const desktopProductSliders = document.querySelectorAll('.product-slider__homepage');

    if(desktopProductSliders.length > 0){
        desktopProductSliders.forEach((element) => {
            var homepageSlider = tns({
                container: element,
                items: 1,
                controls: false,
                loop:false,
                autoHeight: true,
                nav: false,
                preventScrollOnTouch: "auto",
                swipeAngle: 15
            });
            $('.slider-trigger').on('click',function(e){
                setTimeout(() => {
                    homepageSlider.updateSliderHeight();
                }, 500);
            });
        });
    }


    if ($('.product-slider').length) {
        var productSlider = tns({
            container: '.product-slider__wrapper',
            items: 1,
            controls: false,
            mouseDrag: true,
            loop:false,
            autoHeight: true,
            navContainer: '.product-slider__thumb',
            navAsThumbnails: true,
            navPosition: 'bottom',
            preventScrollOnTouch: false
        });

        var productSliderThumb = tns({
            container: '.product-slider__thumb',
            controls: false,
            mouseDrag: true,
            loop:false,
            items: 3.5,
            gutter: 10,
            nav: false,
            preventScrollOnTouch: false,
            responsive: {
                640: {
                    items: 2.5,
                },
                800: {
                    items: 3.5,
                },
                1200: {
                    items: 4.5,
                }
            }
        });
    }


    $('.slider-trigger').on('click',function(e){
        e.preventDefault();
        var target = $(this).data('target');
        $('.slider-item-target').hide();
        $('.slider-item-target[data-target=' + target +']').fadeIn();
    })

    $(document).trigger('scroll');
    $(window).trigger('resize');

    $('.nav-trigger').on('click',function(event){
        event.preventDefault();
        $('.nav-trigger, .site-nav, .site-nav__overlayer, .site-header').toggleClass('open');
        $('body').toggleClass('site-nav-open');
    });

    $('.faq-item').on('click',function(){
        $(this).siblings().find('.answer').slideUp();
        $(this).siblings().removeClass('open');
        $(this).find('.answer').slideToggle();
        $(this).toggleClass('open');
    })

    var didScroll;
    var lastScrollTop = 0;
    var delta = 5;
    var navbarHeight = $(".site-header").outerHeight();

    $(window).on("scroll", function (event) {
        didScroll = true;
    });

    setInterval(function () {
        if (didScroll) {
            hasScrolled();
            didScroll = false;
        }
    }, 250);

    function hasScrolled() {
        var st = $(this).scrollTop();

        // Make sure they scroll more than delta
        if (Math.abs(lastScrollTop - st) <= delta) return;

        if (st > lastScrollTop && st > navbarHeight) {
            if (!$('.mobile-nav').hasClass('visible')) {
                // Scroll Down

                if ($(".announcement-bar").length) {
                    $(".announcement-bar").addClass('nav-up');
                }

            }
        } else {
            // Scroll Up
            if (st + $(window).height() < $(document).height()) {
                if ($(".announcement-bar").length) {
                    $(".announcement-bar").removeClass('nav-up');
                }
            }
        }

        lastScrollTop = st;
    }

    if ($('.quantity').length) {
        var quantity = $('.quantity');
        var quantityVal = quantity.val();

        quantity.on('change',function(){
            quantityVal = quantity.val();
        })

        $('.q-change').on('click',function(e){
            e.preventDefault();

            if ($(this).hasClass('q-add')) {
                quantity.get(0).value++
            } else {
                if (quantityVal > 1) {
                    quantity.get(0).value--
                }
            }
            quantityVal = quantity.val();
        })
        quantity.trigger('change');
    }

    $(document).on('click','.cart-button',function(e){
        e.preventDefault();
        var el = $(this);
        var cartItem = el.closest('.cart-item');
        $('.cart-items-list').addClass('blocked');
        var input = el.parent('.cart-quantity-container').find('input');
        var inputQuantity = parseInt(input.val());
        var element = parseInt(input.data('line'));

        if (el.hasClass('cart-quantity-plus')) {
            var add = inputQuantity + 1;
            axios.post('/cart/change.js',{
                line: element,
                quantity: add
            }).then(function(data){
                $(".cart-popup").load("/ .cart-popup-inner");
            }).catch(function(error){
                if(error.status = 422){
                    var errorMessage = $('<p>', {
                        class: 'out-of-stock-error',
                        text: "You've already added all our stock!"
                      });
                      cartItem.append(errorMessage);

                      setTimeout(function() {
                        axios.post('/cart/change.js',{
                            line: element,
                            quantity: (inputQuantity),
                        }).then(function(){
                            $(".cart-popup").load("/ .cart-popup-inner");
                            errorMessage.remove();
                        })
                      }, 3000);
                }else{
                    console.log(error);
                }
            })
        } else if (el.hasClass('cart-quantity-minus')) {
            var remove = inputQuantity - 1;

            axios.post('/cart/change.js',{
                line: element,
                quantity: remove,
            }).then(function(){
                $(".cart-popup").load("/ .cart-popup-inner");
            }).catch(function(error){
                console.log(error);
            })
        } else if (el.hasClass('cart-remove')) {
            var input_remove = el.parent('.cart-quantity').find('.cart-quantity-container input');
            var element_remove = parseInt(input_remove.data('line'));
            axios.post('/cart/change.js', {
                line: element_remove,
                quantity: 0,
            }).then(function () {
                $(".cart-popup").load("/ .cart-popup-inner");
            }).catch(function (error) {
                console.log(error);
            })
        }
        input.trigger('change');
    })

    document.addEventListener('click',function(e){
        if(e.target){
            var target_classes = e.target.getAttribute('class');
        }
        if(target_classes && target_classes.includes('ajax-add-to-cart')){
            e.preventDefault();
            
            const button = $(e.target);

            var qty = 1;

            if (button.hasClass('add-product-form')) {
                qty = parseInt($('.quantity').val());
            }

            var productId = button.data('product');
            var plan = null;
            if ($('.buy-subscribe').is(':checked')) {
                var plan = $('.frequency').find('option:selected').val();
            }

            axios.post('/cart/add.js',{
                items: [
                    {
                        quantity:qty,
                        id: productId,
                        selling_plan:plan
                    }
                ]
            }).then(function(response){
                $(".cart-popup").load("/ .cart-popup-inner");
                $('.cart-popup').addClass('visible');
                $('.cart-overlay').addClass('visible');
            })
        }
    });

    $('.open-nutrition').on('click',function(e){
        e.preventDefault();
        $('.nutritional-popup').addClass('visible');
    });

    $('.close-popup').on('click',function(e){
        e.preventDefault();
        $('.nutritional-popup').removeClass('visible');
    })

    $('.forgot-password').on('click',function(e){
        e.preventDefault();
        $('.login-form').hide();
        $('.reset-password-section').fadeIn();
    })

    $('.hide-forgot-password').on('click',function(e){
        e.preventDefault();
        $('.reset-password-section').hide();
        $('.login-form').fadeIn();
    })

    $('.edit-address-trigger').on('click',function(){
        var controls = '#' + $(this).attr('aria-controls');
        $(controls).slideToggle();
    })

    $('.edit-cancel').on('click',function(){
        $(this).closest('.edit-address').slideUp();
    });

    $('.new-address-trigger').on('click',function(){
        $('.add-address').slideDown();
    });

    $('.new-address-cancel').on('click',function(){
        $('.add-address').slideUp();
    })

    $('.nutritional__popup-close').on('click',function(e){
        e.preventDefault();
        $('.nutritional__popup').hide();
    });

    $('.accordian__item__question').on('click', function() {
        $('.nutritional__popup').fadeIn(1000);
    });

    // JS Cookies

    if (!Cookies.get("cookieBar")) {
        $(".cookies-bar").addClass("visible");
        $(".accept_button").on("click", function (e) {
            e.preventDefault();
            Cookies.set("cookieBar", true, { expires: 14 });
            $(".cookies-bar").removeClass("visible");
        });

        $(".declined_button").on("click", function (e) {
            e.preventDefault();
            Cookies.set("cookieBar", false, { expires: 14 });
            $(".cookies-bar").removeClass("visible");
        });
    }

    // Subscription

    if ($('.product-form').length) {
        $('.subscription-option input').on('change',function(){
            var el = $(this);
            if (el.hasClass('buy-subscribe')) {
                $('.frequency').slideDown();
                var originalPrice = parseInt($('.product-price').data('original-price'));
                var percentage = parseInt($('.subscribe-percent').data('percent'))/100;
                var discountedPrice =  (originalPrice - (originalPrice*percentage))/100;
                $('.product-price strong').html('&pound;' + discountedPrice.toFixed(2));
            } else {
                $('.frequency').slideUp();
                var originalMoneyPrice = $('.product-price').data('price-money');
                $('.product-price strong').html(originalMoneyPrice);
            }
        });
        $('.subscription-option:first input').trigger('change');
    }

    // Dynamic numbers font

    $(window).on('resize',function(){
        var slideHeight = $('.slide-image:first').height();
        var viewport = $(window).width()/8;
        $('.listing-number').css('fontSize', slideHeight + viewport);

        setTimeout(function(){
            var slideHeight = $('.slide-image:first').height();
            var viewport = $(window).width()/10;
            $('.listing-number').css('fontSize', slideHeight + viewport);
        },100)
    })

    $(window).trigger('resize');

})

let blog = document.querySelectorAll('.blog--recipes'),
    doubleItems = document.querySelectorAll('.large-6.article-block'),
    singleItems = document.querySelectorAll('.large-3.article-block'),
    singleItemsNoImg = document.querySelectorAll('.large-3.article-block .no-image div');

if (singleItems.length > 0 && blog.length == 0){

    const articleItemsInterval = setInterval(articleItems, 100);

    function articleItems(){
        if(singleItems[0].querySelector('.article-block__image div') == null){ return };
        var itemHeight = singleItems[0].querySelector('.article-block__image div').offsetHeight + 'px';
        if (itemHeight != "0px"){
            clearInterval(articleItemsInterval);
            //if (window.innerWidth > 1024){
                if (doubleItems.length > 0) {
                    for (const doubleItem of doubleItems) {
                        const articleBlockImage = doubleItem.querySelector('.article-block__image');
                        if (articleBlockImage) {
                            const articleBlockImageDiv = articleBlockImage.querySelector('div');
                            if (articleBlockImageDiv) {
                                articleBlockImageDiv.style.height = itemHeight;
                            }
                        }
                    }
                }
                if (singleItemsNoImg.length > 0) {
                    for (const singleItemNoImg of singleItemsNoImg) {
                        singleItemNoImg.style.height = itemHeight;
                    }
                }
            //}
            /*else {
                if (doubleItems.length > 0) {
                    for (const doubleItem of doubleItems) {
                        doubleItem.querySelector('.article-block__image div').style.height = null;
                    }
                }
                if (singleItemsNoImg.length > 0) {
                    for (const singleItemNoImg of singleItemsNoImg) {
                        singleItemNoImg.style.height = null;
                    }
                }
            }*/
        }
    }
    window.addEventListener("resize", articleItems);
}


//Announcementbar
const speed = 50;

let target = document.querySelector(".announcement-bar");
let original_html = target.innerHTML;
let new_html = "<div class='ticker-items'>" + original_html + "</div>";
target.innerHTML = new_html;
target.innerHTML += new_html;

let tickerWidth = document.querySelector(".ticker-items").offsetWidth;
let initDuration = tickerWidth / speed;

gsap.to(".ticker-items", {
    duration: initDuration,
    xPercent: -100,
    ease: "none",
    repeat: -1
});

const dropdownToggles = document.querySelectorAll('.menu__link--toggle');
for (const dropdownToggle of dropdownToggles) {
    dropdownToggle.addEventListener('click', function(event) {
        event.preventDefault();
        const dropdown_menu = dropdownToggle.parentElement.querySelector('.menu__dropdown');
        dropdown_menu.classList.toggle('menu__dropdown--active')
    });
}

if (!customElements.get('countdown-timer')) {
    class CountdownTimer extends HTMLElement {
        constructor() {
            super();
            this.input = this;
            /* this.holidays = window.theme.date_picker_holidays; */
            this.endDate = new Date();
            this.noOfDaysToAdd = 0;

            this._second = 1000;
            this._minute = this._second * 60;
            this._hour = this._minute * 60;
            this._day = this._hour * 24;

            this.countdownTimeout = null;
            this.counterVisible = false;
        }
        connectedCallback() {
            /*
            let count = 0;
            if (this.endDate.getHours() < window.theme.date_picker_cutoff) {
                this.endDate.setDate(this.endDate.getDate()+1)
            }
            while (count <= this.noOfDaysToAdd) {
                this.endDate.setDate(this.endDate.getDate()+1);

                if (this.endDate.getDay() != 0 && this.endDate.getDay() != 6 && !this.isHoliday(this.endDate, this.holidays)) {
                    count++;
                }
            }*/

            this.endDate.setHours(window.theme.date_picker_cutoff, 0, 0);

            const originalThis = this;
            this.countdownTimeout = setInterval(function() {
                originalThis.showRemaining(originalThis.input, originalThis.endDate)
            }, 1000);
        }
        showRemaining(area, endDate) {
            const now = new Date();
            const distance = endDate - now;

            if (distance < 0) {
                clearInterval(this.countdownTimeout);

                return;
            } else if (this.counterVisible == false) {
                this.counterVisible = true;
                this.parentElement.style.display = 'list-item';
            }

            const days = Math.floor(distance / this._day) <= 0 ? Math.floor(distance / this._day) : Math.floor(distance / this._day) - 1;
            const hours = Math.floor((distance % this._day) / this._hour);
            const minutes = Math.floor((distance % this._hour) / this._minute);
            const seconds = Math.floor((distance % this._minute) / this._second);

            area.innerHTML = '';

            if (days != 0) {
                if (days > 1) {
                    area.innerHTML += days + ' days ';
                } else {
                    area.innerHTML += days + ' day ';
                }
            }
            if (hours != 0) {
                if (hours > 1) {
                    area.innerHTML += hours + ' hours ';
                } else {
                    area.innerHTML += hours + ' hour ';
                }
            }
            if (minutes != 0) {
                if (minutes > 1) {
                    area.innerHTML += minutes + ' minutes ';
                } else {
                    area.innerHTML += minutes + ' minute ';
                }
            }
            if (seconds != 0) {
                if (seconds > 1) {
                    area.innerHTML += seconds + ' seconds ';
                } else {
                    area.innerHTML += seconds + ' second ';
                }
            }
        }
        isHoliday(dt, arr) {
            var bln = false;

            for ( var i = 0; i < arr.length; i++) {
                if (this.compare(dt, arr[i])) { //If days are not holidays
                    bln = true;
                    break;
                }
            }

            return bln;
        }
        compare(dt1, dt2){
            var equal = false;

            if(dt1.getDate() == dt2.getDate() && dt1.getMonth() == dt2.getMonth() && dt1.getFullYear() == dt2.getFullYear()) {
                equal = true;
            }

            return equal;
        }
    }
    customElements.define('countdown-timer', CountdownTimer);
}
if(document.querySelector('#AjaxinateContainer') != null){
document.addEventListener("DOMContentLoaded", function() {
    var endlessScroll = new Ajaxinate({
        container: '#AjaxinateContainer',
        pagination: '#AjaxinatePagination',
        method: 'click'
    });
  });
}